import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <section id="categories" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("categoriesGridH2")}
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-foreground-600">
          {t("categoriesGridSub")}
        </p>
      </div>

      <div className="mt-10 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 lg:gap-5">
        {categories.map((c) => (
          <a
            key={c.key}
            href={c.url}
            target="_blank"
            rel="noopener nofollow"
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-white transition-transform duration-300 hover:-translate-y-1"
          >
            <div className="h-36 w-full overflow-hidden bg-background-100 md:h-40">
              <img
                src={c.image}
                alt={`${t(`categories.${c.key}`)} - USFans Spreadsheet`}
                title={`${t(`categories.${c.key}`)} - USFans Spreadsheet`}
                className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
              />
            </div>
            <div className="flex items-center justify-between gap-2 p-3 md:p-4">
              <span className="whitespace-nowrap text-sm font-semibold text-foreground-900 md:text-base">
                {t(`categories.${c.key}`)}
              </span>
              <span className="flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 md:text-sm">
                {t("viewCategory")}
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-up-line text-sm"></i>
                </span>
              </span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}